export default {
  header_main: 'Receive / Reject Specimen',
  patient_info: 'Patient Information',
  receiveLab: 'Receive Specimen',
  rejectLab: 'Reject Specimen',
  returnLab: 'Restore Status',
  printOrderReport: 'Print Order Report',
  printSticker: 'Print Sticker',
  Laboratory: 'Laboratory',
  OrderItemId: 'Specimen ID',
  OrderItemDesc: 'Test Item',
  cust_name: 'Department',
  OrderItemLaboratoryName: 'Laboratory Name',
  OrderId: 'Order Number',
  IdCard: 'National ID',
  OrderItemSpecimenType: 'Specimen Type',
  OrderItemPrice: 'Price (Baht)',
  lab_item_status: 'Status',
  lis_sid: 'Specimen Number',
  OrderItemRemark: 'Remark',
  remark: 'Remark',
  PackageNo: 'Package Number',
  PatientName: 'Patient Name',
  HN: 'HN',
  prefix: 'Prefix',
  fullname: 'Full Name',
  firstname: 'First Name',
  middlename: 'Middle Name',
  lastname: 'Last Name',
  birthday: 'Date of Birth',
  age: 'Age',
  sex: 'Gender',
  user_created: 'Ordering Physician',
  date_created: 'Order Date',
  date_send: 'Specimen Sent Date',
  date_receive: 'Specimen Received Date',
  date_result: 'Reported Date',
  collectionDate: 'Collection Date',
  status: 'Status',
  hospitalLabNo: 'Hospital Specimen Number',
  paymentType: 'Payment Type',
  project: 'Project',
  pleaseSpecifyRejectReason: 'Please specify a rejection reason',
  pleaseSendLabFirst: 'Please send the specimen first',
  pleaseSelectData: 'Please select data',
  pleaseSelectSpecimenToReceive: 'Please select the specimen to receive',
  pleaseSelectSpecimenToReturn: 'Please select the specimen to restore',
  warningReceiveAgain: 'Specimens that are already received or rejected cannot be received again. Please reject the previous specimen first.',
  warningReceiveReject: 'Cannot receive a rejected specimen',
  pleaseSelectNotReceive: 'Please select only specimens that are not yet received',
  pleaseSelectReject: 'Please select specimens to reject',
  is_urgent: 'Urgent Result',
  is_get_back: 'Return Specimen',
  statusObj: {
    OP: 'Requested',
    COLLECTION: 'Awaiting Specimen',
    RECEIVEDALL: 'Specimen Received',
    FIRSTAPPROVE: 'Result Reported',
    LASTAPPROVE: 'Result Approved',
    CA: 'Order Cancelled',
    labApprove: 'Result Sent',
    labNotApprove: 'Awaiting Result',
    return: 'Restored',
    reject: 'Rejected',
    receive: 'Received',
    cancelSpecimen: 'Test Item Cancelled',
    receivedReject: 'Received & Rejected',
    receivedRejectSome: 'Partially Received & Rejected',
    rejected: 'Specimen Rejected',
  },
  back: 'Back',
  collectDate: 'Collection Date',
  rejectSpecimen: 'Reject Specimen',
  reason: 'Rejection Reason',
  note: 'Note',
  date: 'Date',
  userHist: 'Result Entered By',
  paymentStatus: 'Payment Status',
  labStatus: 'Order Status',
  labApproveStatus: 'Result Status',
  receivedUser: 'Receiver / Rejector',
  packageNo: 'Package No',
  pleaseGoPayment: 'Unable to receive the specimen because payment confirmation has not been completed.',
  code: 'Code',
  desc: 'Description',
  rejectUser: 'Service Staff',
  cancelOrderItem: 'Cancel & Refund Pending',
  confirmReturnSpecimenTitle: 'Do you want to restore the specimen status?',
  confirmReceiveSpecimenTitle: 'Do you want to receive the specimen?',
  confirmCancelspecimenTitle: 'Do you want to cancel this test item?',
  errorReturnSpecimen: 'Cannot restore specimens with status Not Received or Cancelled.',
  warningRejectAgain: 'Rejected specimens cannot be rejected again.',
  search: 'Search',
  enterReason: 'Please enter a reason',
  pleaseCancalApproveFirst: 'Please cancel approve first',
  returnInvoidError: 'Cannot restore items that have an invoice',
  errorCancelSpecimenThatAlreadyCancel: 'Cannot cancel a test item that has already been cancelled',
  pleaseSelectSpecimenToResent: 'Please select items to resend',
  resentGatewaySuccess: 'Resent successfully',
  receiptGenerated: 'Receipt Generated',
  receiptSent: 'Receipt Sent',
  uploadingFile: 'Please wait while uploading file',
  uploadSuccess: 'File uploaded successfully',
  specimenTypeId: 'Specimen Type ID',
}
